import React, {PropsWithChildren} from "react";
import {createFeatureFlaggingProvider, User, UserOptions} from "ub-feature-flagging-react";
import {getenv} from "../utils/getenv";
import {ProductEnabledProvider} from "./ProductEnabledProvider";

const launchdarklyClientId = getenv("UB_LAUNCHDARKLY_CLIENT_ID");
const FeatureFlaggingProviderRaw = createFeatureFlaggingProvider(launchdarklyClientId);

function getUser(universityId: string | null, universitySlug: string | null) {
    let userOptions: UserOptions = {};
    if (universityId) {
        userOptions = {
            ...userOptions,
            university: {
                id: universityId,
            },
        };
    }
    if (universitySlug) {
        userOptions = {
            ...userOptions,
            university: {
                ...userOptions.university,
                slug: universitySlug,
            },
        };
    }
    const user = new User("assistant-user", userOptions);
    return user;
}

export const FeatureFlaggingProvider = ({children}: PropsWithChildren) => {
    const urlParams = new URLSearchParams(window.location.search);
    const universityId = urlParams.get("universityId");
    const universitySlug = urlParams.get("universitySlug");

    return (
        <FeatureFlaggingProviderRaw user={getUser(universityId, universitySlug)}>
            <ProductEnabledProvider>{children}</ProductEnabledProvider>
        </FeatureFlaggingProviderRaw>
    );
};
